import { render, staticRenderFns } from "./TeamMemberGrid.vue?vue&type=template&id=05244fff&scoped=true&"
import script from "./TeamMemberGrid.vue?vue&type=script&lang=js&"
export * from "./TeamMemberGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05244fff",
  null
  
)

export default component.exports